export default function Funnel({
  width = 420,
  height = 56,
  color = '#5E92A6',
  className = '',
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 412 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="none"
      {...props}
    >
      <path
        d="M1.29814 8.81396C-1.49827 5.23107 1.0547 0 5.5997 0H403.4C407.945 0 410.498 5.23107 407.702 8.81396L372.566 53.8313C371.532 55.1562 369.945 55.9306 368.265 55.9306H40.7352C39.0545 55.9306 37.4677 55.1562 36.4336 53.8313L1.29814 8.81396Z"
        fill={color}
      />
    </svg>
  );
}
